


































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"
import LoadingLogo from "@/components/LoadingLogo.vue"
@Component({ components: { LoadingLogo } })
export default class Software extends Super {
  downloads: any = null

  /**
   * Runs when the component is created- get URLS from the API
   */
  created() {
    this.loadSoftwareDownloads().catch(this.displayError)
  }

  /**
   * Get signed download links from the backend
   */
  async loadSoftwareDownloads() {
    const response = await this.http.get("/software-downloads/latest")
    this.downloads = response.data
  }
}
